import React, { useState, useEffect, useMemo } from "react";
import StudentEdit from "./StudentEdit";
import "./StudentsList.css";

const API_ROOT       = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const DOC_BASE       = "https://pumis.puchd.ac.in/uploads/student_profile_pic/";

function formatDOB(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d)) return String(val).slice(0, 10);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-");
}

export default function StudentVerifiedList() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId  = parseInt(localUser?.moduleId, 10);
  const empId     = parseInt(localUser?.id,       10);
  const deptId    = parseInt(localUser?.deptid,   10);

  const [students, setStudents] = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [editId,   setEditId]   = useState(null);

  const fetchStudents = async () => {
    setError(""); setLoading(true);
    try {
      const params = new URLSearchParams({ moduleId, empId, deptId });
      const res  = await fetch(`${API_ROOT}/api/students/verified-list?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch students.");
      setStudents(data.data || []);
    } catch (err) {
      setError(err.message || "Failed to fetch students.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moduleId !== 5) return;
    fetchStudents();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (moduleId !== 5) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Student List (for Issuing Parking Sticker)</h3>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading && <div className="alert alert-info">Loading...</div>}

      {!loading && !error && students.length === 0 && (
        <div className="alert alert-info">No students found.</div>
      )}

      {students.length > 0 && (
        <div className="table-responsive">
          <table className="pending-verif-table table table-sm table-bordered stu-list-table">
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th>SNo</th>
                <th>Name</th>
                <th>Father's Name</th>
                <th>Mobile</th>
                <th>DOB</th>
                <th>PUPIN</th>
                <th>Course</th>
                <th>Department</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Active</th>
                <th>VehicleNo</th>
                <th>StickerNo</th>
                <th>Doc</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {students.map((stu, idx) => (
                <tr key={stu.StudentID}>
                  <td>{idx + 1}</td>
                  <td className="stu-name-col">{stu.StudentName}</td>
                  <td>{stu.FatherName}</td>
                  <td>{stu.Mobile}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{formatDOB(stu.DOB)}</td>
                  <td>{stu.PUPIN}</td>
                  <td>{stu.CourseAbb}</td>
                  <td>{stu.Department}</td>
                  <td className="stu-addr-col">{stu.PermanentAddress}</td>
                  <td>{stu.City}</td>
                  <td>{stu.State}</td>
                  <td>{stu.Active}</td>
                  <td>{stu.VehicleNo}</td>
                  <td>{stu.StickerNo}</td>
                  <td>
                    {stu.ProfilePic ? (
                      <a
                        href={`${DOC_BASE}${stu.ProfilePic}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-secondary"
                      >
                        View
                      </a>
                    ) : (
                      <span style={{ color: "red" }}>No Document</span>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => setEditId(stu.StudentID)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {editId && (
        <StudentEdit
          studentId={editId}
          moduleId={moduleId}
          onClose={() => setEditId(null)}
          onSaved={() => { setEditId(null); fetchStudents(); }}
        />
      )}
    </div>
  );
}
